/**
 * El estado de **sin acceso** de Revenue, el único de esta pantalla con
 * contenido propio.
 *
 * Cargando y error se fueron a `modules/comunes/estados`, que es donde quedó la
 * única implementación y el único vocabulario de los tres estados de bloque.
 */
import type { Role } from '@ops/contracts'

import { AccessDenied } from '../../ui'

export interface SinAccesoProps {
  /** Rol del usuario, cuando se lo pudo resolver. */
  rol?: Role
  /** Mensaje del backend, cuando el 403 vino de la API. */
  mensaje?: string
}

/**
 * Revenue es solo Admin. El servidor ya devuelve 403 y la sidebar no muestra el
 * link: esto es para cuando alguien entra por URL o cuando la API rechaza el
 * payload. Esconder el link es cortesía, el permiso lo aplica la API.
 *
 * El estado en sí es `AccessDenied` de `src/ui/`: lo comparte con las guardas del
 * router y con Adquisición, así que el texto de una negativa es uno solo. Acá
 * queda únicamente lo que es propio de esta sección — qué datos son los que no se
 * ven, que es lo que la persona necesita saber para pedir el que le falta.
 */
export function SinAcceso({ rol, mensaje }: SinAccesoProps) {
  return (
    <AccessDenied
      seccion="Revenue"
      permitidos={PERMITIDOS}
      {...(rol === undefined ? {} : { rol })}
      {...(mensaje === undefined ? {} : { mensaje })}
      detalle={
        <p className="mt-2 text-meta leading-relaxed text-muted-strong">
          Lo que se recorta es la facturación entera: MRR, ARR, ticket promedio,
          margen y las suscripciones. No es una restricción de esta pantalla, es
          del payload que manda la API.
        </p>
      }
    />
  )
}

const PERMITIDOS: readonly Role[] = ['admin']
